import React from 'react'
import PropTypes from 'prop-types'

import humanize from 'underscore.string/humanize'

import Translator     from '/components/translator'
import ReactSelect    from '/components/react-select'

$w = (str)-> (t for t in str.split(' ') when t isnt '')

betas =
  "BETA": $w 'limit_host_added_fees_to_50_percent_of_the_ticket_price host_added_fee_presets fees_by_point_of_sale'
  "BETA: Custom Confirmation Emails": $w 'customizable_confirmation_emails_beta customizable_confirmation_emails'
  "BETA: Reports": $w 'event_summary_settlement_report tm_audit_report box_office_report ticket_counts_report attraction_report payout_settlement_report'
  "BETA: Web Box Office": $w 'enable_additional_payment_types'
  "PRE-BETA": $w 'facility_fee'

betaColors = $w '#4e78f1 #ff8864 #00c7af #fdb624'

export default \
class FeatureMatrix extends React.Component
  @propTypes:
    org:      PropTypes.object.isRequired
    onChange: PropTypes.func.isRequired

  options: ->
    [
      label: 'Enabled'
      value: true
    ,
      label: 'Disabled'
      value: false
    ]

  onChange: (key, obj)->
    if obj?
      value = obj.value
    else
      value = null

    @props.onChange key, value

  renderFeatureTitle: (key)->
    return 'PayPal' if key == 'paypal'
    humanize key

  betaFor: (feature)->
    for key, vals of betas
      return key if feature in vals
    null

  render: ->
    <table className="table table-striped">
      <thead>
        <tr>
          <th>Feature</th>
          <th>Plan</th>
          <th>Override</th>
          <th>Result</th>
        </tr>
      </thead>
      <tbody>
        {for beta, idx in [null, ...Object.keys betas]
          @renderRow key, val, idx for key, val of @props.org.features when @betaFor(key) is beta
        }
      </tbody>
    </table>

  renderRow: (key, val, idx)=>
    <tr key={key}>
      <td>
        {@renderFeatureTitle key}
        <span
          className="label label-xs"
          style={{ backgroundColor: betaColors[idx % betaColors.length], marginLeft: '1em', verticalAlign: 'text-bottom' }}
        >
          {"#{@betaFor key}" if @betaFor key}
        </span>
      </td>
      <td>
        <Translator value={@props.org.plan.features[key]}/>
      </td>
      <td>
        <ReactSelect
          value={@props.org.features_overrides[key]}
          onChange={@onChange.bind @, key}
          options={@options()}
          placeholder="plan default"
        />
      </td>
      <td>
        <Translator value={@props.org.features[key]}/>
      </td>
    </tr>
